import { render, staticRenderFns } from "./GalleriesListView.vue?vue&type=template&id=53adcb18&"
import script from "./GalleriesListView.vue?vue&type=script&lang=js&"
export * from "./GalleriesListView.vue?vue&type=script&lang=js&"
import style0 from "./GalleriesListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCol,VPagination,VRow})
